function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { Col, Container, Row } from "reactstrap";
const StyledContainer = styled(Container)`
  border-radius: .2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  position: relative;
  white-space: normal;
  cursor: pointer;
`;

const ToggleOpenTrigger = ({
  children,
  onClick,
  withoutPadding,
  ...restProps
}) => {
  if (withoutPadding) {
    return /*#__PURE__*/React.createElement(StyledContainer, _extends({
      onClick: onClick
    }, restProps), /*#__PURE__*/React.createElement(Row, null, children));
  }

  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    onClick: onClick
  }, restProps), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: '12'
  }, children)));
};

export default ToggleOpenTrigger;